import api from "../../api/index";

const getrecords = `${process.env.VUE_APP_BASE_URI}/enterprise/records`;

const addrecord = `${process.env.VUE_APP_BASE_URI}/enterprise/record`;

const fetchsinglerecord = `${process.env.VUE_APP_BASE_URI}/enterprise/record`;

const deleterecord = `${process.env.VUE_APP_BASE_URI}/enterprise/record`;
const endrecord = `${process.env.VUE_APP_BASE_URI}/enterprise/record/end`;
const startrecord = `${process.env.VUE_APP_BASE_URI}/enterprise/record/start`;

const getDefaultState = () => {
  return {
    records: [],
    record: [],
    status: "",
  };
};

const state = getDefaultState();

const getters = {
  records: (state) => state.records,
  record: (state) => state.record,
};

const actions = {
  async getRecords({ commit }) {
    commit("getrecords_request");
    const res = await api.get(getrecords);
    if (res.data.status === "success") {
      commit("getrecords_success", res.data.records);
    }
    return res;
  },

  async getSingleRecord({ commit }, id) {
    commit("getsinglerecord_request");
    const res = await api.get(`${fetchsinglerecord}/${id}`);
    if (res.data.status === "success") {
      commit("getsinglerecord_success", res.data);
    }
    return res;
  },

  async addRecord({ commit }, newRecord) {
    commit("addrecord_request");
    const res = await api.post(addrecord, newRecord);
    if (res.data.status === "success") {
      commit("addrecord_success");
    }
    return res;
  },

  async deleteRecord({ commit }, id) {
    commit("deleterecord_request");
    const res = await api.delete(`${deleterecord}/${id}`);
    if (res.data.status === "success") {
      commit("deleterecord_success");
    }
    return res;
  },

  async endRecord({ commit }, id) {
    commit("endrecord_request");
    const res = await api.put(`${endrecord}/${id}`);
    if (res.data.status === "success") {
      commit("endrecord_success");
    }
    return res;
  },

  async startRecord({ commit }, id) {
    commit("startrecord_request");
    const res = await api.put(`${startrecord}/${id}`);
    if (res.data.status === "success") {
      commit("startrecord_success");
    }
    return res;
  },

  async resetRecordsState({ commit }) {
    await commit("resetrecordsstate_success");
  },
};

const mutations = {
  getrecords_request: (state) => (state.status = "loading"),
  getrecords_success: (state, records) => {
    state.status = "success";
    state.records = records;
  },
  getsinglerecord_request: (state) => (state.status = "loading"),
  getsinglerecord_success: (state, record) => {
    state.status = "success";
    state.record = record;
  },
  addrecord_request: (state) => (state.status = "loading"),
  addrecord_success: (state) => (state.status = "success"),
  deleterecord_request: (state) => (state.status = "loading"),
  deleterecord_success: (state) => (state.status = "success"),
  endrecord_request: (state) => (state.status = "loading"),
  endrecord_success: (state) => (state.status = "success"),
  startrecord_request: (state) => (state.status = "loading"),
  startrecord_success: (state) => (state.status = "success"),
  resetrecordsstate_success: (state) => Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
